import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Divider,
  Chip,
  Box,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import AutoBidMatrixLogsService from "../services/externalServices/autoBidMatrixLogServices";

function AutoBidMatrixLogDetailsDialog({ logData }) {
  const [logDetails, setLogDetails] = useState(null);
  const [loading, setLoading] = useState(true); // NEW
  const [error, setError] = useState(null);     // NEW

  useEffect(() => {
    getLogData();
  }, []);

  const getLogData = async () => {
    try {
      const response = await AutoBidMatrixLogsService.getLogById(logData);
      setLogDetails(response);
    } catch (err) {
      console.error("Error fetching log data:", err);
      setError("Failed to load log details.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={4}>
        <CircularProgress />
        <Typography sx={{ ml: 2 }}>Loading log details...</Typography>
      </Box>
    );
  }

  if (error || !logDetails) {
    return (
      <Box>
        <Typography variant="h6" color="error">
          {error || "Log details are not available."}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {/* Title Section */}
      <Typography variant="h4" gutterBottom>
        Auto-Bid Matrix Log
      </Typography>

      <Divider>
        <Chip label="Metadata" />
      </Divider>

      <Box mt={2}>
        <Typography variant="body1">
          <strong>Service Associated:</strong>{" "}
          {logDetails.serviceAssociated || "N/A"}
        </Typography>
        <Typography variant="body1">
          <strong>City:</strong>{" "}
          {logDetails.cityId?.cityName?.en || logDetails.cityId?._id || "N/A"}
        </Typography>
        <Typography variant="body1">
          <strong>Created At:</strong>{" "}
          {logDetails.created_at
            ? new Date(logDetails.created_at).toLocaleString()
            : "N/A"}
        </Typography>
      </Box>

      <Divider sx={{ my: 2 }}>
        <Chip label="Request Params" />
      </Divider>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2">
            <strong>Tour Package ID:</strong>{" "}
            {logDetails.params?.tourPackageId || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>AC Required:</strong>{" "}
            {logDetails.params?.isAc ? "Yes" : "No"}
          </Typography>
          <Typography variant="body2">
            <strong>Selected Date:</strong>{" "}
            {logDetails.params?.selectedDate
              ? new Date(logDetails.params.selectedDate).toLocaleString()
              : "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>Selected Time:</strong>{" "}
            {logDetails.params?.selectedTime
              ? new Date(logDetails.params.selectedTime).toLocaleString()
              : "N/A"}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body2">
            <strong>Pickup Location:</strong>{" "}
            {logDetails.params?.pickupLocation?.title || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>Pickup SubText:</strong>{" "}
            {logDetails.params?.pickupLocation?.subText || "N/A"}
          </Typography>
          <Typography variant="body2">
            <strong>Cruze IDs:</strong>{" "}
            {logDetails.params?.cruzeIds?.join(", ") || "N/A"}
          </Typography>
        </Grid>
      </Grid>

      <Divider sx={{ my: 2 }}>
        <Chip label="Log Messages" />
      </Divider>

      <Box>
        {logDetails.logs?.length > 0 ? (
          <List>
            {logDetails.logs.map((log, index) => (
              <ListItem key={index} disableGutters>
                <ListItemText
                  primary={
                    <Typography
                      variant="body2"
                      sx={{ whiteSpace: "pre-wrap" }}
                    >
                      {log}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="textSecondary">
            No log messages available.
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export default AutoBidMatrixLogDetailsDialog;
